module.exports = __webpack_public_path__ + "img/Maskgroup.9395ea75.svg";